angular.module('lsnBase.deprecated.models')
  .factory('BankAccountModel', ['LsnBankAccountModelV1',
    function(LsnBankAccountModelV1) {
      return LsnBankAccountModelV1;
    }
  ]);